import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable jsx-a11y/no-autofocus */
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useCallback } from 'react';
import { CloseDialogButton } from './CloseDialogButton';
export const ConfirmationDialog = (props) => {
    const { onConfirm, onReject, open, title, description, confirmText } = props;
    const handleAgree = useCallback(() => {
        onConfirm();
    }, [onConfirm]);
    const handleDisagree = useCallback(() => {
        onReject();
    }, [onReject]);
    return (_jsx("div", { children: _jsxs(Dialog, { open: open, onClose: handleDisagree, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", children: [title && _jsx(DialogTitle, { id: "alert-dialog-title", children: title }), _jsx(CloseDialogButton, { onClose: handleDisagree }), _jsx(DialogContent, { children: _jsx(DialogContentText, { id: "alert-dialog-description", children: description }) }), _jsx(DialogActions, { children: _jsx(Button, { onClick: handleAgree, color: "primary", autoFocus: true, children: confirmText }) })] }) }));
};
